import { gsap } from 'gsap';
import { ScrollToPlugin } from 'gsap/ScrollToPlugin';

gsap.registerPlugin(ScrollToPlugin);

export class ScrollToMenu {
  private _menu: HTMLElement;
  private _menu_items: NodeListOf<HTMLAnchorElement>;
  private _sections: NodeListOf<HTMLElement>;

  constructor() {
    this._menu = document.querySelector('.c-scroll-to-menu');
    this._menu_items = document.querySelectorAll('.c-scroll-to-menu__item');
    this._sections = document.querySelectorAll('[id^="scroll-to-"]');
    this._addEventListeners();
  }

  private _addEventListeners(): void {
    this._menu_items.forEach((item) => {
      item.addEventListener('click', this._scrollToSection.bind(this));
    });
  }

  private _scrollToSection(event: Event): void {
    event.preventDefault();
    const targetId = (event.currentTarget as HTMLAnchorElement)
      .getAttribute('href')
      .substring(1);
    const targetSection = document.getElementById(`scroll-to-${targetId}`);

    if (targetSection) {
      gsap.to(window, {
        duration: 0.5,
        scrollTo: { y: targetSection, offsetY: 100 },
        ease: 'power2.inOut',
      });
    }
  }
}
